import { dateToString } from './dateToString'

export const normalizeWitness = (data, id) => {
  const first_name = data[`witness_first_name_${id}`]
  const middle_name = data[`witness_middle_name_${id}`]
  const last_name = data[`witness_last_name_${id}`]
  const suffix = data[`witness_suffix_${id}`]
  const alias_nickname = data[`witness_alias_nickname_${id}`]
  const home_phone = data[`witness_home_phone_${id}`]
  const cell_phone = data[`witness_cell_phone_${id}`]
  const work_phone = data[`witness_work_phone_${id}`]
  const employer = data[`witness_employer_${id}`]
  const employer_phone = data[`witness_employer_phone_${id}`]
  const employer_address = data[`witness_employer_address_${id}`]
  const personal_email = data[`witness_email_${id}`]
  const work_email = data[`witness_work_email_${id}`]
  const address = data[`witness_address_${id}`]
  const dob = data[`witness_dob_${id}`]
  const job_title = data[`witness_job_title_${id}`]

  return {
    first_name,
    middle_name,
    last_name,
    suffix,
    alias: alias_nickname,
    email: personal_email,
    dob: dob && dateToString(dob),
    phone: cell_phone,
    phone2: home_phone,
    address: address && address.line1Value,
    address2: address && address.line2Value,
    city: address && address.cityValue,
    state: address && address.stateValue,
    zip: address && address.zipValue,
    country: address && address.countryValue,
    employment: {
      employer,
      job_title,
      address: employer_address && employer_address.line1Value,
      address2: employer_address && employer_address.line2Value,
      city: employer_address && employer_address.cityValue,
      state: employer_address && employer_address.stateValue,
      zip: employer_address && employer_address.zipValue,
      country: employer_address && employer_address.countryValue,
      phone: employer_phone,
      phone2: work_phone,
      email: work_email
    }
  }
}

/**
 * All witness data is optional, which means that we have to traverse the object and if a single
 * data point has a value, then it's a valid witness. The only caveat is that we provide a default
 * value for `country` which means we have to remove it from the data points we're testing.
 */

export const isValid = obj =>
  Object.values(obj).some(val => val && val.length > 0)

export const isValidEmployment = obj => {
  const clone = { ...obj }
  delete clone.country
  return isValid(clone)
}

export const isValidWitness = witness => {
  const clone = { ...witness }
  delete clone.country
  const { dob, employment, ...rest } = clone
  const validInfo = isValid(rest)
  const validEmployment = isValidEmployment(employment)
  const validDob = dob && isValid(dob)
  return validInfo || validEmployment || validDob
}

export const normalizeWitnessData = (data, maxIndex = 0, index = 0) => {
  let witnesses = []

  for (let id = index; id <= maxIndex; id++) {
    witnesses.push(normalizeWitness(data, id))
  }

  return witnesses.filter(wit => isValidWitness(wit))
}
